import styles from "./styles.module.css";

const JetFirsatBannerPriceIndex = () => {
  return (
    <div className={styles.wrapper}>
      <span className={styles.logo}>JETFIRSAT</span>
      <p className={styles.content}>
        Bu ilana, yapay zeka teknolojileri kullanılarak tahmini bir fiyat değerlemesi yapılmıştır. Benzer konum ve
        özellikteki emsallerine göre <span>daha avantajlı fiyata</span> sahiptir.
      </p>
    </div>
  );
};

export default JetFirsatBannerPriceIndex;
